// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"502":"ucare-panel-chunk","868":"ucare-widget-chunk"}[chunkId] || chunkId) + "." + {"218":"1df3e18f","502":"4edf9796","868":"a5d9a13a"}[chunkId] + ".chunk.js";
};